import moment from 'moment';
import DatePickerMui from '../../../../../components/common/DatePickerMui';
import formatDate from '../../../../../components/common/formatDate';
import { TableCompHead } from '../../../../../components/ui';

interface IProps {
  moduleData: any;
  isView: boolean;
  setDateRender: React.Dispatch<React.SetStateAction<boolean>>;
}
const colSpanCalc = (head: string) => {
  if (head === 'OBSERVATION') return 5;
  if (head === 'SHEET SPEC./TOLERANCE') return 2;
  return 1;
};
const THead = ({ moduleData, isView, setDateRender }: IProps) => {
  return (
    <thead>
      <TableCompHead
        colSpan={21}
        rowSpan={3}
        labels={['DOC NO.-', 'REV. NO.-', 'DATE:-']}
        values={['FM/QA/24', '00', '18.06.17']}
        heading="RAW MATERIAL RECEIPT INSPECTION REPORT "
      />
      <tr>
        <th colSpan={21} align="left">
          Date:{' '}
          {isView ? (
            formatDate(moduleData.moduleData_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.moduleData_date)}
              onChange={(date) => {
                moduleData.moduleData_date = date;
                setDateRender((prev) => !prev);
              }}
            />
          )}
        </th>
      </tr>
      <tr>
        {[
          'DATE',
          'SUPPLIER',
          'PART NAME ',
          'RM GRADE',
          'SIZE',
          'QUANTITY (KG)',
          'Batch No/Heat No/Lot No',
          'INSP. METHOD',
          'SHEET SPEC./TOLERANCE',
          'OBSERVATION',
          'Free from visual defects',
          'RESULT',
          'INSPECTED BY',
          'VERIFIED BY',
        ].map((head) => (
          <th
            rowSpan={head === 'OBSERVATION' ? 1 : 2}
            colSpan={colSpanCalc(head)}
            style={{
              textTransform: 'uppercase',
            }}
          >
            {head}
          </th>
        ))}
        <th style={{ textTransform: 'uppercase' }} colSpan={2} rowSpan={2}>
          Remarks
        </th>
      </tr>
      <tr>
        {Array.from({ length: 5 }, (_, index) => (
          <th style={{ width: '90px' }} key={index + 'Heading'}>
            {index + 1}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
